import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { Heading, ListingCard, ListingCardSkeletons, NamedLink } from '../../components';

import css from './ListingPage.module.css';

/**
 * "You may also like" — a row of related products so a shopper who isn't sold
 * on this one has somewhere to go other than the back button.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.listing>} [props.listings] the related listings
 * @param {boolean} [props.inProgress] whether the query is still running
 * @returns {JSX.Element|null} null once we know there is nothing to recommend
 */
const SectionSimilarListings = props => {
  const { listings = [], inProgress } = props;

  if (!inProgress && listings.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionSimilarListings}>
      <div className={css.similarListingsHeader}>
        <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
          <FormattedMessage id="ListingPage.similarListingsTitle" />
        </Heading>
        <NamedLink name="SearchPage" className={css.similarListingsViewAll}>
          <FormattedMessage id="ListingPage.similarListingsViewAll" />
        </NamedLink>
      </div>

      <div className={css.similarListingsGrid}>
        {inProgress
          ? ListingCardSkeletons({ count: 4 })
          : listings.map(l => (
              <ListingCard key={l.id.uuid} listing={l} className={css.similarListingCard} />
            ))}
      </div>
    </section>
  );
};

export default SectionSimilarListings;
